import { render, staticRenderFns } from "./AuthorDetail.vue?vue&type=template&id=d1515bd6&scoped=true"
import script from "./AuthorDetail.vue?vue&type=script&lang=js"
export * from "./AuthorDetail.vue?vue&type=script&lang=js"
import style0 from "./AuthorDetail.vue?vue&type=style&index=0&id=d1515bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1515bd6",
  null
  
)

export default component.exports